module.exports = __webpack_public_path__ + "static/media/googleIcon.5539e647.png";